module.exports = __webpack_public_path__ + "static/media/523JamesPBrawleyDrNW_2018-06-12_92.435704de.jpg";